import { useState, useEffect, useCallback } from 'react';
import { useAddCaseFormContext } from '../contexts/AddCaseFormContext';
import { useParams } from 'react-router-dom';
import useCaseFieldUpdate from './useCaseFieldUpdate';
import useMedicalButton from './useMedicalButton';
import { buildMedicalProviderPaths } from '../utils/caseFieldPaths';
import { generateDefaultProviderName } from '../utils/helper';
import { UPDATE_CASE_ACTION } from '@demandproai/shared';

const useProviderName = ({ providerIndex, providerType }) => {
    const { formik, selectedTiffIndex } = useAddCaseFormContext();
    const { caseId } = useParams();

    const { updateCase } = useCaseFieldUpdate({ caseId });
    const medicalproviderPaths = buildMedicalProviderPaths({ selectedTiffIndex, providerType });

    const providerName = formik.values.clients[selectedTiffIndex].medicalProviders?.[providerType]?.medicalRecords?.[providerIndex]?.providerName
        || generateDefaultProviderName(formik.values.clients[selectedTiffIndex]?.personalInfo?.clientName, providerIndex);

    const getIsDuplicateProviderName = useCallback((e, index) => {
        return Boolean(formik.values.clients[selectedTiffIndex].medicalProviders?.[providerType]?.medicalRecords?.find((obj, objIndex) =>
            objIndex !== index && obj.providerName.trim().toLowerCase() === e.target.value.trim().toLowerCase()
        ));
    }, [formik.values, selectedTiffIndex, providerType]);

    const { isButonDisabled, checkProviderName } = useMedicalButton(true, getIsDuplicateProviderName);

    const [isEditing, setIsEditing] = useState(false);
    const [localProviderName, setLocalProviderName] = useState('');

    useEffect(() => {
        setLocalProviderName(providerName);
    }, [providerName]);

    const handleSave = async () => {
        formik.setFieldValue(`clients[${selectedTiffIndex}].medicalProviders.${providerType}.medicalRecords.${providerIndex}.providerName`, localProviderName);
        await updateCase?.({ data: { [medicalproviderPaths.providerName(providerIndex)]: localProviderName }, action: UPDATE_CASE_ACTION.UPDATE });
        setIsEditing(false);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setLocalProviderName(providerName);
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleChange = (e) => {
        checkProviderName(e, providerIndex);
        setLocalProviderName(e.target.value);
    };

    return {
        providerName,
        isEditing,
        localProviderName,
        isButonDisabled,
        handleSave,
        handleCancel,
        handleEdit,
        handleChange
    };
};

export default useProviderName;
